import { Flex, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';

export default function GridCard ({ title, backgroundImage, href, type, isExternal }) {
  return (
    <Stack>
      <LinkBox>
        <LinkOverlay 
          href={href} 
          target='_blank'
          rel='noopener noreferrer'
        >
          <Flex 
                maxW="100%"
                minH="200px"
                justify="center"
                align="center"
                bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${backgroundImage})`}
                bgSize="cover"
                bgRepeat="no-repeat"
                //borderRadius={10}
                className={type}
          >
            <Text
              whiteSpace="pre-line"
              align="center"
              color="white"
              //textTransform="uppercase"
              fontWeight="bold"
              fontFamily="GerTT"
              fontSize="xl"
              textShadow={'2px 1px 1px rgba(0, 0, 0, 0.88)'}
              opacity={1.0}
              >
                {title}
              </Text>
          </Flex>
        </LinkOverlay>
      </LinkBox>
    </Stack>
  );
};
